// src/services/favorite.service.js
import axios from "axios";
import { BaseUrl } from "../App";
import BuyerServicesUrl from "../BuyerServicesUrl";
import { mapProduct } from "../models/Product/ProductResponseModel";

export const fetchFavorites = async (token) => {
  const res = await axios.get(
    BaseUrl + BuyerServicesUrl.GetProductsFavoriteList,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

  return res.data?.data?.data?.map(mapProduct) || [];
};
